export default {
      id: "tt-bold-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.0b648a3c.svg#tt-bold",
      toString: function () {
        return this.url;
      }
    }